'use client'
import moment from 'moment'
import { Open_Sans } from 'next/font/google'
import Image from 'next/image'
import Link from 'next/link'

const open = Open_Sans({ subsets: ['latin'] })

export default function BlocoNoticeHome({ props }: any) {
  const dia = moment(props.attributes.post_date).format('DD')
  const mes = moment(props.attributes.post_date).format('M')
  const mounth = [
    'JAN',
    'FEV',
    'MAR',
    'ABR',
    'MAI',
    'JUN',
    'JUL',
    'AGO',
    'SET',
    'OUT',
    'NOV',
    'DEZ',
  ][parseInt(mes) - 1]

  return (
    <div style={open.style} className="group mb-10 grid grid-cols-5">
      <div className="col-span-5 h-52 sm:mb-3 lg:p-1 ">
        <Link
          href={`/noticia/${props.attributes.slug}`}
          aria-label="Notícias"
          className="mb-0"
        >
          <Image
            src={`${props.attributes.thumbnail.data.attributes.url}`}
            className="mb-4 h-48 w-full cursor-pointer border-gray-400 object-cover p-1 lg:border-[1px]"
            alt="Clique para saber mais"
            width={250}
            height={150}
            sizes="(max-width: 250px) 100vw, (max-width: 300px) 50vw, 33vw"
            priority={true}
          />
        </Link>
      </div>
      <div className="col-span-1 row-span-2">
        <div className="flex flex-col flex-wrap items-center border-2 border-yellow-600 pb-1 pt-2 group-hover:bg-yellow-600">
          <span className="text-lg font-bold leading-4 text-yellow-600 group-hover:text-white">
            {dia}
          </span>
          <span className="text-xs font-bold uppercase text-yellow-600 group-hover:text-white">
            {mounth}
          </span>
        </div>
      </div>
      <div className="col-span-4 row-span-1 ml-3">
        <div className="flex flex-col flex-wrap items-start">
          <Link
            href={`/noticia/${props.attributes.slug}`}
            className="mb-4 block h-16 cursor-pointer text-lg leading-5 text-black group-hover:text-yellow-600"
            aria-label={props.attributes.title.substring(0, 50) + '...'}
          >
            {props.attributes.title.substring(0, 50) + '...'}
          </Link>
          <h2 className="block h-10 text-xs leading-5">
            {props.attributes.subtitle.substring(0, 75) + '...'}
          </h2>
          <hr className="mt-2 w-3/12 border-b-4 border-b-yellow-600" />
        </div>
      </div>
    </div>
  )
}
